import {User} from "@/services/models/User";
import BimsHttpService from "@/services/BimsHttpService";

class UserService {
    /**
     * @description Retrieves the user with the specified email address
     */
    getUser(emailAddress: string): Promise<User> {
        return BimsHttpService.get(`${process.env.VUE_APP_API_BASE_URL}/users/${emailAddress}`)
            .then(r => r.data)
    }
}

export default new UserService()
